// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1DLbK","inputDescription":"styles_inputDescription__266sy"};